module.exports = __webpack_public_path__ + "img/QueenOfPain.18b5f32d.png";